import 'src/css/aiassistant.css';
import { withTranslation } from "react-i18next";
import { Col, Row } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from "react-router-dom";

class UserMessage extends Component {
    render() {
        return (<Row className='aimessage'>
            <Row>
                <Col>
                    <div className='aiicon'>
                        <div className='aiuser-img text-primary bg-light-primary'>{this.props.initials}</div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className='aitext text-gray-800'>{this.props.message}</p>
                </Col>
            </Row>
        </Row>);
    }
}


const mapStateToProps = (state) => {
    return {
        photo: state.agent.photo,
        initials: state.agent.initials,
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    return <UserMessage {...props} navigate={navigate} />
}

export default compose(connect(mapStateToProps, {}), withTranslation())(WithNavigate);